import api from './api'

export default {
  // Crear financiador
  createFinancingParty(data) {
    return api.post('/financingParties', data)
  },

  // Verificar si existe un apoderado por email
  checkFinancingPartyByEmail(email) {
    return api.get(`/financingParties/email/${email}`)
  },

  // Obtener apoderado por RUT
  getFinancingPartyByRut(rut) {
    return api.get(`/financingParties/rut/${encodeURIComponent(rut)}`)
  },

  // Actualizar financiador
  updateFinancingParty(financingPartyId, data) {
    return api.put(`/financingParties/${financingPartyId}`, data)
  }
}